.root {
  /* Logical properties, so a right-to-left locale needs no second stylesheet. */
  border-block-end: 1px solid var(--lw-border);
  padding-block-end: var(--mantine-spacing-sm);
  margin-block-end: var(--mantine-spacing-md);
}

/* The heading takes focus after a route change; without this the ring would never be seen. */
.root h1:focus-visible {
  outline: var(--lw-focus-ring-width) solid var(--lw-focus-ring);
  outline-offset: var(--lw-focus-ring-offset);
}
